import { selector } from 'recoil';
import {
  accountListStateAtom,
  accountSearchTextAtom,
} from '../atoms/account_atoms';
import { accountListInterface } from '../interfaces/account_interfaces';

export const filteredAccountsSelector = selector<
  accountListInterface['accounts']
>({
  key: 'filteredAccountsSelector',
  get: ({ get }) => {
    const { accounts } = get(accountListStateAtom);
    const searchText = get(accountSearchTextAtom).toLowerCase();

    const isSearchTextEmpty =
      !searchText || !searchText.replace(/\s/g, '').length;

    try {
      return isSearchTextEmpty
        ? accounts.slice()
        : accounts.filter(account => {
            const firstName = account.first_name.toLowerCase();
            const lastName = account.last_name.toLowerCase();
            const email = account.email.toLowerCase();

            return (
              firstName.match(searchText) ||
              lastName.match(searchText) ||
              `${firstName} ${lastName}`.match(searchText) ||
              email.match(searchText)
            );
          });
    } catch (e) {
      console.error('Error filtering accounts:', e);
      return [];
    }
  },
});
